export default __webpack_public_path__ + "static/media/pw.791b7053.svg";